import React from 'react';
import './style.scss';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Tooltip from "@material-ui/core/es/Tooltip/Tooltip";
import moment from "moment";

export default function OrderRedirect(props) {
    function handleOrderRedirect() {
        props.redirectOrder(props.order.bid, props.order.id, props.redirectToBid);
    }

    const isReadySlaPassed = props.readySla !== undefined && props.readySla !== null && props.order.status === 'ACCEPTED' && moment.duration(moment().diff(moment(new Date(props.order.orderTime)))).asMinutes() >= props.readySla

    function isTouchDevice() {
        return 'ontouchstart' in document.documentElement;
    }

    return (
        <span
            className={"order-redirect order-redirect-next" + (isReadySlaPassed ? " order-redirect-ready-sla-passed" : "")}>
        <span className="order-redirect-content"
              onClick={(e) => {
                  if (!isTouchDevice())
                      handleOrderRedirect()
              }}
              onTouchEnd={(e) => {
                  handleOrderRedirect()
              }}>
                <Tooltip disableHoverListener={props.disabled}
                         disableTouchListener={props.disabled}
                         disableFocusListener={true}
                         arrow
                         title={"העבר הזמנה"}>
                    <span className="order-redirect-icon-container">
                            <span
                                className={`order-redirect-icon-button order-redirect-next-icon-button` + (props.disabled ? ' order-status-disabled-icon-button' : '')}>
                                    <NavigateNextIcon/>
                            </span>
                    </span>
                </Tooltip>
        </span>
        </span>
    );
}
